export default function showPrices() {
	const pricesToggle = document.querySelector('.js-show-prices');

	if(!pricesToggle) {
		return;
	}

	pricesToggle.addEventListener('click', function() {
		const prices = document.querySelector('.product-prices');

		prices.classList.toggle('is-active');
	});
}